import { render, staticRenderFns } from "./ResultButtons.vue?vue&type=template&id=4f6aa9a6&scoped=true&lang=pug&"
import script from "./ResultButtons.vue?vue&type=script&lang=js&"
export * from "./ResultButtons.vue?vue&type=script&lang=js&"
import style0 from "./ResultButtons.vue?vue&type=style&index=0&id=4f6aa9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6aa9a6",
  null
  
)

export default component.exports